import React, { useState } from 'react';
import './Navbar.css'; // Importing the separate CSS file
import { FaTwitter, FaFacebookF, FaInstagram, FaBars } from 'react-icons/fa';
import { MdEmail, MdPhone, MdAccessTime } from 'react-icons/md';
import { ImCross } from "react-icons/im";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  return (
    <header className="custom-navbar-container">
      <div className="custom-top-bar">
        <div className="custom-contact-info">
          <div className="custom-contact-item"><MdEmail className="custom-icons" /> <span>petburialvijayawada@gmail.com</span></div>
          <div className="custom-contact-item"><MdPhone className="custom-icons" /> <span>6304692989</span></div>
          <div className="custom-contact-item2"><MdAccessTime className="custom-icons2" /> <span>24/7 Services</span></div>
        </div>
      </div>
      <nav className="custom-main-nav">
        <div className="custom-logo-container">
        <li><Link to="/" > <img src="images/Blue_Retro_Animals___Pets_Logo__4_-removebg-preview.png" alt="Logo" className="custom-logo"/></Link></li>

         
        </div>
        <div className="custom-hamburger" onClick={toggleMobileNav}>
        {isMobileNavOpen ? <ImCross /> : <FaBars />}
        </div>
        <ul className={`custom-nav-links ${isMobileNavOpen ? 'custom-mobile-nav-open' : ''}`}>
          <li><Link to="/" onClick={toggleMobileNav}>Home</Link></li>
          <li><Link to="/about" onClick={toggleMobileNav}>About Us</Link></li>
          <li><Link to="/Services" onClick={toggleMobileNav}>Services</Link></li>
          <li><Link to="/Contact" onClick={toggleMobileNav}>Contact</Link></li>
          <li><Link to="/Donate" onClick={toggleMobileNav}>Donate</Link></li>
        </ul>
        <div className="custom-social-icons">
          <FaTwitter className="custom-social-icon" />
          <FaFacebookF className="custom-social-icon" />
          <FaInstagram className="custom-social-icon" />
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
